export const signInApp = {
  "SignInPage.Email.Input": "signIn-email",
  "SignInPage.Password.Input": "signIn-pwd",
  "SignInPage.Submit.Button": "signIn-submit-btn",
};
